import {Icon16MailOutline, Icon16Phone} from "@vkontakte/icons";
import React from "react";

function ClubManagerCard(props) {
    const {manager_club} = props

    return <div key="managerFFCInfo" className="main-page_manage-info ">
        <p className="my-manage">Ваш менеджер {props.current_club.name}</p>
        <p className="name-manage">{manager_club['meta']['manager']['lastname'] + ' ' + manager_club['meta']['manager']['name']}</p>
        <p className="tel-manage">

            <Icon16Phone/>
            <a
                href={"tel:+7" + manager_club['meta']['manager']['phone']}>{manager_club['meta']['manager']['phone'] ? "+7 " + manager_club['meta']['manager']['phone'] : 'Не задано в 1С'}</a>
        </p>
        <p className="tel-manage email-manage">
            <Icon16MailOutline/>
            <a target="_blank"
               href={"mailto:" + manager_club['meta']['manager']['email']}>
                {manager_club['meta']['manager']['email'] ? manager_club['meta']['manager']['email'] : 'Не задано в 1С'}
            </a>
        </p>
        <p className="email-manage">Должность:
            {manager_club['meta']['manager']['position']} </p>

    </div>
}

export default ClubManagerCard